var chunkToChildrenMap = {
	"5124": [
		8172,
		6403,
		9239,
		2216,
		4103,
		5080,
		5243,
		257,
		1933,
		7033,
		5967,
		6010,
		9168,
		2622,
		1282
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));